import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bc56886e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid page" }
const _hoisted_2 = { class: "page__content" }
const _hoisted_3 = { class: "page__header" }
const _hoisted_4 = { class: "asahi-logo-header" }
const _hoisted_5 = { class: "d-flex align-items-center justify-content-end primary-white" }
const _hoisted_6 = { class: "page__footer" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  "data-v-ded6a882": "",
  class: "hr mb-2"
}, null, -1))
const _hoisted_8 = { class: "page__footer-text asahi-body-bold-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "http://www.alkohol.info.hu",
  target: "_blank",
  class: "page__footer-link asahi-body-bold-2"
}, "www.alkohol.info.hu", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiLogoNew = _resolveComponent("AsahiLogoNew")!
  const _component_AsahiLanguageSelector = _resolveComponent("AsahiLanguageSelector")!
  const _component_AsahiTypography = _resolveComponent("AsahiTypography")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_AsahiLogoNew, {
            onClick: _cache[0] || (_cache[0] = () => _ctx.$navigate('/login'))
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          (!!_ctx.activeLanguage)
            ? (_openBlock(), _createBlock(_component_AsahiLanguageSelector, {
                key: 0,
                languages: _ctx.languages,
                activeLanguage: _ctx.activeLanguage,
                onLanguagechange: _cache[1] || (_cache[1] = (event) => _ctx.changeLanguage(event))
              }, null, 8, ["languages", "activeLanguage"]))
            : _createCommentVNode("", true),
          _createVNode(_component_AsahiTypography, {
            type: "subtitle-1-bold",
            color: "primary-white",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$navigate('/login'))),
            class: "login-button text-center"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Login')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      (_ctx.$route.fullPath === '/contact')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.$t('Enjoy responsibly')), 1),
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('For adults only, 18 and older')), 1)
            ]),
            _hoisted_10
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}